import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, PackageCheck, PlusCircle, Users, MoreHorizontal, BarChart3, FlaskConical, Settings, CreditCard, Download, LogOut, Store } from "lucide-react";
import { useAuth, canSimulate } from "../lib/auth";
import { usePwa, install } from "../lib/pwa";
import { useScrollLock } from "../lib/menus";

const TABS = [
  ["/overblik", "Overblik", Home, "home"],
  ["/pickup", "Udlevering", PackageCheck, "pickup"],
  ["/offers/new", "Nyt tilbud", PlusCircle, "new"],
  ["/customers", "Kunder", Users, "customers"],
];
const MORE = [
  ["/stats", "Statistik", BarChart3, "stats"],
  ["/simulator", "Simulator", FlaskConical, "simulator"],
  ["/settings", "Indstillinger", Settings, "settings"],
  ["/billing", "Abonnement", CreditCard, "billing"],
];

const isActive = (path, href) => path.startsWith(href);

function MoreSheet({ path, onClose }) {
  const { logout, store } = useAuth();
  const nav = useNavigate();
  const { canInstall } = usePwa();
  useScrollLock(true);
  return (
    <>
      <div className="sheet-scrim" onClick={onClose} data-testid="more-sheet-scrim" />
      <div className="sheet" role="dialog" aria-label="Mere" data-testid="more-sheet">
        <div className="grab" />
        {MORE.filter(([href]) => href !== "/simulator" || canSimulate(store)).map(([href, label, Icon, id]) => (
          <Link key={href} to={href} className={`sheet-item${isActive(path, href) ? " active" : ""}`} data-testid={`more-${id}`}>
            <Icon size={20} /> {label}
            {href === "/settings" && store?.fb_health?.status === "error" && <span className="nav-dot" data-testid="more-settings-dot" />}
          </Link>
        ))}
        {canInstall && (
          <button className="sheet-item" onClick={() => { onClose(); install(); }} data-testid="more-install">
            <Download size={20} /> Installer app
          </button>
        )}
        {!store?.staff && !store?.is_owner && (
          <Link to="/butikker" className={`sheet-item${isActive(path, "/butikker") ? " active" : ""}`} data-testid="more-stores">
            <Store size={20} /> Butikker · Tilføj butik
          </Link>
        )}
        <button className="sheet-item danger" onClick={() => { logout(); nav("/"); }} data-testid="more-logout">
          <LogOut size={20} /> Log ud
        </button>
      </div>
    </>
  );
}

export default function BottomNav() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => setOpen(false), [pathname]);
  const { store } = useAuth();
  const fbErr = store?.fb_health?.status === "error";
  const moreActive = MORE.some(([href]) => isActive(pathname, href));
  return (
    <>
      <nav className="bottom-nav" data-testid="bottom-nav">
        {TABS.map(([href, label, Icon, id]) => (
          <Link key={href} to={href} className={`${isActive(pathname, href) ? "active" : ""} bn-${id}`} aria-current={isActive(pathname, href) ? "page" : undefined} data-testid={`bottom-nav-${id}`}>
            <Icon size={22} />
            <span>{label}</span>
          </Link>
        ))}
        <button className={moreActive || open ? "active" : ""} onClick={() => setOpen((o) => !o)} data-testid="bottom-nav-more">
          <span className="bn-ic">
            <MoreHorizontal size={22} />
            {fbErr && <span className="nav-dot" data-testid="bottom-more-dot" />}
          </span>
          <span>Mere</span>
        </button>
      </nav>
      {open && <MoreSheet path={pathname} onClose={() => setOpen(false)} />}
    </>
  );
}
